'use strict';

import $ from 'jQuery';

// This is a base class and should only ever be extended to set API end point.
export default class GenericTabContainer {
  constructor(options) {
    this.activeTab = null;
    this.basePath = null;
    this.$baseTab = null;
    this.$breadCrumb = null;
    this.$links = null;
    this.$sections = null;
    this.enableBreadCrumb = null;
    this.breadCrumbStateAttribute = null;
    this.skipFirstPageInHistory = null;
    this.options = options || {};
  }

  initialize() {
    this.initializeDefaults();
    this.initializeElements();
    this.initializeBaseRoute();
    this.initializeTabs();
    this.initializeState();
    this.initializePopState();
  }

  initializeDefaults() {
    this.componentSelector = this.options.componentSelector || 'StatefulTabContainer';
    this.selectedClass = this.options.selectedClass || 'is-selected';
    this.sectionKeyAttribute = this.options.sectionKeyAttribute || 'data-tab-section-key';
    this.sectionIdAttribute = this.options.sectionIdAttribute || 'data-tab-section-id';
    this.sectionTabBaseAttribute = this.options.sectionTabBaseAttribute || 'data-tab-base';
    this.breadCrumbStateAttribute = this.options.breadCrumbStateAttribute || 'data-tab-breadcrumb-state';
    this.enableBreadCrumb =  this.options.enableBreadCrumb || false;
    this.skipFirstPageInHistory = this.options.skipFirstPageInHistory || false;
  }

  initializeElements() {
    if (this.enableBreadCrumb) {
      this.$breadCrumb = $('.Breadcrumb');
      this.$breadCrumbContent = this.$breadCrumb.find('.Content');
      let $breadCrumbs = this.$breadCrumb.find('.Breadcrumb-item');
      this.$breadCrumbTemplate = $breadCrumbs.last()
        .clone()
        .attr('data-tab-breadcrumb-state', true);
    }

    this.$el = $(this.options.el);
    this.$links = this.$el.find(`[${this.sectionKeyAttribute}]`);
    this.$sections = this.$el.find(`[${this.sectionIdAttribute}]`);
  }

  initializeBaseRoute() {
    this.$baseTab = this.$el.find(`[${this.sectionTabBaseAttribute}]`);
    this.basePath = this.$baseTab.attr('href');
  }

  initializeState() {

    // Get current url path
    let pathName = window.location.pathname;

    // Look for links with that
    let $el = this.$el.find(`a[${this.sectionKeyAttribute}][href="${pathName}"]`);

    $el.length ? this.setState($el, this.skipFirstPageInHistory) : this.setFistTab();
  }

  initializePopState() {
    window.onpopstate = (event) => {
      if (event.state) {
        let $el = this.$el.find(`[${this.sectionKeyAttribute}="${event.state.key}"]`);
        this.setState($el, true);
      }
    }
  }

  initializeTabs() {
    this.$links.on('click', (e) => {
      e.preventDefault();

      this.setState($(e.target));
    });
  }

  setState($el, popped) {
    let key = $el.attr(this.sectionKeyAttribute);

    if (!popped) {
      history.pushState({ key }, null, $el.attr('href'));
    }

    if (this.enableBreadCrumb) {
      this.updateBreadCrumb($el);
    }

    // Cleanup active tabs
    this.unsetSelectedTab();

    this.setSelectedTab($el);
    this.setSelectedPane($el.attr(this.sectionKeyAttribute));
  }

  setFistTab() {
    this.setState(this.$baseTab);
  }

  /**
   * override point for extending generic tab container and where to
   * put the is selected class
   */
  setSelectedTab($el) {
    $el.show();
  }

  setSelectedPane(key) {
    this.$el.find(`[${this.sectionIdAttribute}="${key}"]`).show();
  }

  unsetSelectedTab() {
    this.$sections.hide();
    this.$el.find('.MfrNewDesign').show();
    this.$el.find(`.${this.selectedClass}`).removeClass(this.selectedClass);
  }

  updateBreadCrumb($el) {
    let sectionKey  = $el.attr(this.sectionKeyAttribute);
    let $breadCrumb = this.createBreadCrumbElement(sectionKey);

    // Breadcrumb cleanup
    this.$breadCrumb.find(`[${this.breadCrumbStateAttribute}]`).remove();

    // append our new bread crumb to the template
    this.$breadCrumbContent.append($breadCrumb);
  }

  createBreadCrumbElement(sectionKey) {
    let $breadCrumb = this.$breadCrumbTemplate.clone();

    let $spans = $breadCrumb.find('span');

    // Get the breadcrumb's name
    let text = this.$el.find(`[${this.sectionKeyAttribute}="${sectionKey}"]`)
      .html();

    // Set breadcrumbs name, prepend with a slash to indicate that it is a new top level
    $spans.first()
      .html(`/ ${text}`);

    return $breadCrumb;
  }
}

export function create($parent) {
  $parent.find(`.${this.componentSelector}`).each((_, el) => {
    new GenericTabContainer({ el })
  });
}



// WEBPACK FOOTER //
// ./assets/components/GenericTabContainer/GenericTabContainer.js